
import Loader from "react-loader-spinner";
import { Table, Button, Popover, Form, OverlayTrigger, FormGroup, Col } from "react-bootstrap";
import { Fragment, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { ArrowsAngleExpand, Check2Square, CheckLg, Download, List, Pencil, PencilSquare, PlusCircle, PlusSquare, Trash, Upload } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import NewNumberInput from "../../Components/NewNumberInput";
import {
    addOrUpdateProduct, updateAllProductsPrice, deleteGrouping, editProductGrouping, getAllProductHolders, getAllProductTypes,
    getLastCode, getProduct, getProductAttachments, getProductByCallback, setImagePopup
} from "../store/api/GetAllProduct";
import { setSelectCostCenterPopup, setSelectProductGroupPop } from "../store/api/Modals";
import ModalSelectCostCenter from "../Components/ModalSelectCostCenter";
import ModalSelectProductGroup from "../Components/ModalSelectProductGroup";
import { attachFile, deleteAttachment, downloadFile } from "../../store/api/CommonFunctions";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getImageServerPath } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";

const AddEditProduct = () => {
    const { id } = useParams();
    const [productImorter, setPI] = useState(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const attachInput = useRef();
    const productImage = useRef();
    const [lastCode, setCode] = useState(null);
    const settingNames = ['ProductGrouppingType', 'Product_ExtAttr1_Title', 'Product_ExtAttr2_Title'];
    const [isPending, setPending] = useState(false);
    const { register, handleSubmit, errors } = useForm();
    const [selectedCostCenter, selectCostCenter] = useState(null);
    const [partOrProduct, setPartORProduct] = useState("محصول");
    let [productGroups, setProductGroups] = useState([]);
    const [product, setProuctData] = useState({});

    const { typeList, holderList, attachmentList, settings } = useSelector(state => {
        return {
            //product: state.ProductReducer.product,
            typeList: state.ProductReducer.productTypeList,
            holderList: state.ProductReducer.productHolderList,
            attachmentList: state.ProductReducer.attachmentList,
            settings: state.SystemSettingsReducer.systemSettings
        }
    });
    function onSubmit(data) {
        if (Number(settings?.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue) === 1)
            if (!productGroups || productGroups.length === 0) {
                setErrorDialog(dispatch, `گروهی برای ${partOrProduct} انتخاب نشده است`, `ثبت اطلاعات ${partOrProduct}`);
                return;
            }
        if (Array.isArray(data.UsedInServices)) {
            data.UsedInServices = data.UsedInServices.some(s => s === "on");
        }
        if (Array.isArray(data.UsedInStorage)) {
            data.UsedInStorage = data.UsedInStorage.some(s => s === "on");
        }
        if (!id || Number(id) === 0) {
            data.ProductGroups = productGroups;
        }
        else {
            data.ID = Number(id);
        }
        data.TypeID = typeList.find(t => t.Name === data.Name)?.ID;
        setPending(true);
        const onSuccess = (p) => {
            setPending(false);
            history.replace("/BaseInfo/AddEditProduct/" + p.ID);
        }
        dispatch(addOrUpdateProduct(data, onSuccess));
    }
    function showCostCenterPop() {
        dispatch(setSelectCostCenterPopup({ show: true, onSelect: selectCostCenter }));
    }
    function showSelectGroupPop() {
        const onSelectG = (groups) => {
            if (!groups || groups.length === 0) {
                return;
            }
            // let distinctGroups = [];
            // for (let i = 0; i < groups.length; i++) {
            //     if (!productGroups.find(g => g.GroupID === groups[i].GroupID)) {
            //         distinctGroups.push(groups[i]);
            //     }
            // }
            // if (distinctGroups.length === 0) {
            //     return;
            // }
            if (Number(id) > 0) {
                groups.forEach(g => g.ProductID = id);
                dispatch(editProductGrouping(/*distinctGroups*/[...groups]));
            }
            //const oldGroups = productGroups.slice();
            //const newGroups = oldGroups.concat(distinctGroups);
            setProductGroups(/*newGroups*/[...groups]);
        }
        dispatch(setSelectProductGroupPop({ show: true, onSelect: onSelectG }));
    }
    function deleteFromList(groupID) {
        const newGroups = productGroups.filter(p => p.GroupID !== groupID);
        if (Number(id) > 0) {
            const onSuccess = () => {
                setProductGroups(newGroups);
            }
            dispatch(deleteGrouping(id, groupID, onSuccess));
        }
        else {
            setProductGroups(newGroups);
        }
    }
    function attach() {
        dispatch(attachFile(attachInput.current, id, "ProductAttachment", () => { dispatch(getProductAttachments(id)); }, "", true));
    }
    function uploadImage() {
        dispatch(attachFile(productImage.current, id, "ProductImage", () => { dispatch(getProduct(id)); }));
    }
    function delAttach(itemID) {
        dispatch(deleteAttachment(itemID, "ProductAttachment", () => { dispatch(getProductAttachments(id)); }))
    }
    const download = (id) => {
        downloadFile(id, "ProductAttachment");
    }
    const magnify = (imageName) => {
        const onSuccess = (res) => {
            if (res.FilePath) {
                dispatch(setImagePopup({ status: "show", imageUrl: res.FilePath }));
            }
        }
        getImageServerPath(imageName, onSuccess);

    }
    function gotoNewProduct() {
        history.push("/BaseInfo/AddEditProduct/0");
    }
    function setProductImporter(e) {
        setPI(e.target.value);
        if (e.target.name !== "Importer")
            e.target.style.height = (e.target.scrollHeight + 2) + "px";
    }
    function onChangePartOrProduct(e) {
        if (e.target.value === "true") {
            setProuctData({ ...product, PartOrProductStr: "قطعه" });
        }
        else {
            setProuctData({ ...product, PartOrProductStr: "قطعه" });
        }
    }

    const popImporter = (
        <Popover style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Content className="bodyStyle">
                <FormGroup >
                    <Form.Control as="textarea" style={{ height: "max-content", textAlign: "justify" }} rows={(productImorter?.length ?? 0) / 71 + 1} defaultValue={productImorter ?? ""} maxLength={2000} onChange={setProductImporter} />
                </FormGroup>
            </Popover.Content>
        </Popover>
    )
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-اطلاعات پایه";
        dispatch(getSystemSettings(settingNames));
        dispatch(getAllProductTypes());
        dispatch(getAllProductHolders(null));
    }, [])
    useEffect(() => {
        if (Number(id) > 0) {
            dispatch(getProductAttachments(id));
            const onSuccess = (res) => {
                setProuctData(res);
                if (res?.ID) {
                    const groups = res.ProductGroups;
                    if (groups && groups.length > 0) {
                        const g = groups.slice();
                        setProductGroups(g);
                    }
                    setPI(res.Importer);
                    if (res.ProductOrPart) {
                        setPartORProduct("قطعه");
                    }
                    else {
                        setPartORProduct("محصول");
                    }
                }
            }
            getProductByCallback(id, onSuccess)
        }
        else {
            setProuctData("PENDING");
            const onGetCode = (res) => {
                if (Number(res) > 0) {
                    setProuctData({ KalaCode: res });
                }
            }
            getLastCode(onGetCode);
        }
    }, [id])
    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle">
                    <FontAwesomeIcon icon={faBoxOpen} size="lg" style={{ marginLeft: "4px", padding: "0.5px" }} />اطلاعات {partOrProduct}
                </div>
                <div className="card-body bodyStyle" style={{ textAlign: "right" }}>
                    <ModalSelectCostCenter />
                    <ModalSelectProductGroup />
                    {product === "PENDING" &&
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <Loader width={30} height={30} color="#bb1370" type="BallTriangle" />
                        </div>
                    }
                    {product !== "PENDING" &&
                        <form onSubmit={handleSubmit(onSubmit)} readOnly>
                            <div className="row">
                                <Col md={2} className="form-group">
                                    <label>کالا محصول است یا قطعه؟</label>
                                    <select className="form-control" name="ProductOrPart" ref={register({})}
                                        onChange={onChangePartOrProduct}
                                        defaultValue={product?.ProductOrPart ?? ""} >
                                        <option value={false}>محصول</option>
                                        <option value={true}>قطعه</option>
                                    </select>
                                </Col>
                                <div className="form-group col-md-2">
                                    <label>کد {partOrProduct}</label><span style={{ color: "red" }}>*</span>
                                    <input type="number" className="form-control" name="KalaCode" ref={register({ required: true })}
                                        defaultValue={product?.KalaCode ?? ""} readOnly={Number(id) > 0} />
                                    {errors.KalaCode && <small className="errors">کد کالا وارد نشده است</small>}
                                </div>
                                {Number(settings?.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue) !== 1 &&
                                    <Fragment>
                                        <div className="form-group col-md-2">
                                            <label>مارک {partOrProduct}</label><span style={{ color: "red" }}>*</span>
                                            {holderList === "PENDING" &&
                                                <div className="form-control">
                                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                                </div>
                                            }
                                            {holderList && Array.isArray(holderList) &&
                                                <select name="HolderID" ref={register({ required: true })} className="form-control"
                                                    defaultValue={product?.HolderID ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {holderList.map((item, i) => <option key={i} value={item.ID}>{item.HolderName}</option>)}
                                                </select>
                                            }
                                            {errors.HolderID && <small className="errors">مارک {partOrProduct} وارد نشده است</small>}
                                        </div>

                                        <div className="form-group col-md-2">
                                            <label>نوع {partOrProduct}</label><span style={{ color: "red" }}>*</span>
                                            {typeList === "PENDING" &&
                                                <div className="form-control">
                                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                                </div>
                                            }
                                            {typeList && Array.isArray(typeList) &&
                                                <select name="Name" ref={register({ required: true })} className="form-control"
                                                    defaultValue={product?.Name ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {typeList.map((item, i) => <option key={i} value={item.Name}>{item.Name}</option>)}
                                                </select>
                                            }
                                            {errors.Name && <small className="errors">نوع {partOrProduct} وارد نشده است</small>}
                                        </div>
                                    </Fragment>
                                }
                                {Number(settings?.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue) === 1 &&
                                    <div className="form-group col-md-2">
                                        <label>نام {partOrProduct}</label><span style={{ color: "red" }}>*</span>
                                        <input type="text" className="form-control" name="Name" ref={register({ required: true })}
                                            defaultValue={product?.Name ?? ""} />
                                        {errors.Name && <small className="errors">نام {partOrProduct} وارد نشده است</small>}
                                    </div>
                                }
                                <div className="form-group col-md-2">
                                    <label>مدل {partOrProduct}</label><span style={{ color: "red" }}>*</span>
                                    <input type="text" className="form-control" name="Model" ref={register({ required: true })}
                                        defaultValue={product?.Model ?? ""} />
                                    {errors.Model && <small className="errors">نام {partOrProduct} وارد نشده است</small>}
                                </div>

                                <div className="form-group col-md-2">
                                    <label>شرح {partOrProduct}</label>
                                    <input id="ProductImporter" type="text" className="form-control" name="Importer" ref={register({})}
                                        value={productImorter ?? ""} onChange={setProductImporter} />
                                    <OverlayTrigger overlay={popImporter} trigger="click" placement="left">
                                        <Button className="btn-input-tiny" style={{ top: 26 }}><ArrowsAngleExpand size={21} /></Button>
                                    </OverlayTrigger>
                                </div>
                                <div className="form-group col-md-2">
                                    <label>آدرس در انبار</label>
                                    <input type="text" className="form-control" name="SecondName" ref={register({})}
                                        defaultValue={product?.SecondName ?? ""} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>بارکد</label>
                                    <input type="text" className="form-control" name="BarCode" ref={register({})}
                                        defaultValue={product?.BarCode ?? ""} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>کارخانه سازنده</label>
                                    <input type="text" className="form-control" name="Manufacturer" ref={register({})}
                                        defaultValue={product?.Manufacturer ?? ""} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>{settings?.find(s => s.SettingName === "Product_ExtAttr1_Title")?.SettingValue}</label>
                                    <input type="text" className="form-control" name="ExtAttr1" ref={register({})}
                                        defaultValue={product?.ExtAttr1 ?? ""} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>{settings?.find(s => s.SettingName === "Product_ExtAttr2_Title")?.SettingValue}</label>
                                    <input type="text" className="form-control" name="ExtAttr2" ref={register({})}
                                        defaultValue={product?.ExtAttr2 ?? ""} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>مدت گارانتی(ماه)</label>
                                    <input type="number" className="form-control" name="GaranteeTimeInMonth" ref={register({})}
                                        defaultValue={product?.GaranteeTimeInMonth ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>مدت گارانتی از نصب(ماه)</label>
                                    <input type="number" className="form-control" name="GuranteeFromFirstInstall" ref={register({})}
                                        defaultValue={product?.GuranteeFromFirstInstall ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>مهلت نصب(روز)</label>
                                    <input type="number" className="form-control" name="InstallDeadLine" ref={register({})}
                                        defaultValue={product?.InstallDeadLine ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>قیمت خرید</label>
                                    <NewNumberInput className="form-control" inputname="PurchasePrice" reff={register({})}
                                        defaultValue={product?.PurchasePrice ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>قیمت فروش گارانتی</label>
                                    <NewNumberInput className="form-control" inputname="GauranteeSalePrice" reff={register({})}
                                        defaultValue={product?.GauranteeSalePrice ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>قیمت فروش آزاد</label>
                                    <NewNumberInput className="form-control" inputname="SalePrice" reff={register({})}
                                        defaultValue={product?.SalePrice ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>قیمت فروش سوم</label>
                                    <NewNumberInput className="form-control" inputname="SalePrice3" reff={register({})}
                                        defaultValue={product?.SalePrice3 ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>مقدار کمینه در انبار</label>
                                    <input type="number" className="form-control" name="MinCountInStorage" ref={register({})}
                                        defaultValue={product?.MinCountInStorage ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>مقدار بیشینه در انبار</label>
                                    <input type="number" className="form-control" name="MaxCountInStorage" ref={register({})}
                                        defaultValue={product?.MaxCountInStorage ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>ضریب خدمات</label>
                                    <input type="number" className="form-control" name="DefinedServicesCoefficient" ref={register({})}
                                        defaultValue={product?.DefinedServicesCoefficient ?? 0} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label>مرکز هزینه</label>
                                    <input type="hidden" name="CostCenterID" ref={register({})} readOnly
                                        value={selectedCostCenter !== null ? selectedCostCenter.ID : product?.CostCenterID ?? ""} />
                                    <input type="text" className="form-control" readOnly
                                        value={selectedCostCenter !== null ? selectedCostCenter.CenterName : product?.CostCenterName ?? ""} />
                                    <Button className="btn-input-tiny" onClick={showCostCenterPop}><List size={20} style={{ top: "26px" }} /></Button>
                                </div>
                                <div className="form-group col-md-2">
                                    <label>شناسه مالیاتی</label>
                                    <input type="text" className="form-control" name="IDForTaxOffice" ref={register({})}
                                        defaultValue={product?.IDForTaxOffice ?? ""} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label></label>
                                    <div style={{ border: "solid 1px #534082", borderRadius: "3px", padding: ".450rem .75rem", marginTop: "6px" }}>
                                        <input type="checkbox" className="form-check-input" name="UsedInServices" ref={register({})}
                                            defaultChecked={product?.UsedInServices ?? true} />
                                        &nbsp;
                                        <span style={{ color: "blue" }}>کاربرد در سرویس های نصب و تعمیر</span>
                                    </div>
                                </div>
                                <div className="form-group col-md-2">
                                    <label></label>
                                    <div style={{ border: "solid 1px #534082", borderRadius: "3px", padding: ".450rem .75rem", marginTop: "6px" }}>
                                        <input type="checkbox" className="form-check-input" name="UsedInStorage" ref={register({})}
                                            defaultChecked={product?.UsedInStorage ?? true} />
                                        &nbsp;
                                        <span style={{ color: "blue" }}>کاربرد در انبارداری</span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {Number(id) > 0 &&
                                    <div className="col-md-4 mt-3">
                                        <label style={{ color: "blue", fontWeight: "bold" }}>تصویر {partOrProduct}</label>
                                        <hr style={{ margin: "5px 0 5px 0", color: "blue", height: "2px", }} />
                                        <div className="form-group" style={{ marginTop: "5px" }}>
                                            <input type="file" className="form-control tableRowInput" style={{ display: "inline-block", width: "80%" }} ref={productImage} />
                                            <Button className="group-Btn-smalll" style={{ marginTop: "-8px" }} onClick={uploadImage}><Upload size={17} /></Button>
                                        </div>
                                        <img src={"data:image;base64," + product?.ProductImage} style={{ height: "80px", marginTop: "5px", cursor: "zoom-in" }}
                                            onClick={() => magnify(product?.ProductImageUrl)} />
                                    </div>
                                }
                                {Number(id) > 0 &&
                                    <div className="col-md-4 mt-3">
                                        <label style={{ color: "blue", fontWeight: "bold" }}>پیــوست ها</label>
                                        <hr style={{ margin: "5px 0 5px 0", color: "blue", height: "2px", }} />
                                        <Table className="fixedTable mt-1" style={{ marginBottom: "0px" }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "55%" }}> نام فایل پیوست </th>
                                                    <th style={{ width: "25%" }}>تاریخ پیوست</th>
                                                    <th style={{ width: "20%" }}>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attachmentList && Array.isArray(attachmentList) && attachmentList.map((item, i) =>
                                                    <tr key={i} className="resultTableRow">
                                                        <td style={{ width: "55%" }}>{item.AttachFileName}</td>
                                                        <td style={{ width: "25%" }}>{item.PAttachDate}</td>
                                                        <td style={{ width: "20%" }}>
                                                            <Trash color="red" size={16} className="rowBtn" onClick={() => delAttach(item.ID)} />
                                                            &nbsp;&nbsp;
                                                            <Download color="blue" size={16} className="rowBtn" onClick={() => download(item.ID)} />
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                        <div className="form-group" style={{ marginTop: "5px" }}>
                                            <input type="file" className="form-control tableRowInput" style={{ display: "inline-block", width: "80%" }} ref={attachInput} />
                                            <Button className="group-Btn-smalll" style={{ marginTop: "-8px" }} onClick={attach}><Upload size={17} /></Button>
                                        </div>
                                    </div>
                                }
                                {Number(settings?.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue) === 1 &&
                                    <div className="col-md-4 mt-3">
                                        <label style={{ color: "blue", fontWeight: "bold" }}>گروهبنــدی</label>
                                        &nbsp;
                                        {Number(id) > 0 ?
                                            <PencilSquare color="#ff7c00" size={17} style={{ cursor: "pointer" }} onClick={showSelectGroupPop} /> :
                                            <PlusCircle color="green" size={18} style={{ cursor: "pointer" }} onClick={showSelectGroupPop} />
                                        }

                                        <hr style={{ margin: "5px 0 5px 0", color: "blue", height: "2px", }} />
                                        <Table className="fixedTable">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "40%" }}> گروه اصلی </th>
                                                    <th style={{ width: "40%" }}>گروه فرعی</th>
                                                    <th style={{ width: "20%" }}>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productGroups && Array.isArray(productGroups) && productGroups.map((item, i) =>
                                                    <tr key={i} className="resultTableRow">
                                                        <td style={{ width: "40%" }}>{item.MainGroupName}</td>
                                                        <td style={{ width: "40%" }}>{item.GroupName}</td>
                                                        <td style={{ width: "20%" }}><Trash color="red" size={16} className="rowBtn" onClick={() => deleteFromList(item.GroupID)} /></td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>

                                    </div>}
                            </div>
                            <Button type="submit" variant="success" className="group-Btn-large mt-2" disabled={isPending}>
                                {Number(id) > 0 ?
                                    <>
                                        <Pencil size={17} />&nbsp;ویرایش اطلاعات
                                    </> :
                                    <>
                                        <CheckLg size={18} />&nbsp;ثبت اطلاعات
                                    </>
                                }
                            </Button>
                            {Number(id) > 0 &&
                                <>
                                    <Button className="group-Btn-large mt-2" disabled={isPending} onClick={gotoNewProduct}>
                                        <PlusSquare size={17}>&nbsp;کالای جدید</PlusSquare>
                                    </Button>
                                </>
                            }
                        </form>
                    }
                </div>
            </div>
        </div >)
}
export default AddEditProduct;